import { MerchantNoteLabel } from './enums';
import { FilterLabels, ILabelPermissions } from './types';

export const getDefaultFilterLabels = (
  labelPermissions: ILabelPermissions,
): FilterLabels => {
  const { sales: canAddSalesNote, support: canAddSupportNote } =
    labelPermissions;

  if (canAddSalesNote === canAddSupportNote) {
    return ['', MerchantNoteLabel.SALES, MerchantNoteLabel.SUPPORT];
  }

  const labels: FilterLabels = [''];
  if (canAddSalesNote) {
    labels.push(MerchantNoteLabel.SALES);
  }
  if (canAddSupportNote) {
    labels.push(MerchantNoteLabel.SUPPORT);
  }

  return labels;
};
